import React, { useState, useEffect, useMemo } from 'react';
import {
  Button,
  Typography,
  MenuItem,
  FormControlLabel,
  Checkbox,
  TextField,
  colors,
} from '@material-ui/core';
import { Formik } from 'formik';
import { useRootStore } from '../../../../stores/BridgeProvider';
import { ButtonFlex, StyledForm } from '../../../styles/styles';
import Spinner from '../../../util/Spinner';
import SimpleSelect from '../../../util/SimpleSelect';

const AddField = ({ json, updateTemplateJSON, handleClose }) => {
  const [fieldType, setFieldType] = useState(null);

  const addNewItem = newItem => {
    const newItems = [...json.items, newItem];

    updateTemplateJSON({ template: json.template, items: newItems });
  };

  const fieldTypeList = [
    { name: 'Text Input', type: 'string' },
    { name: 'Amount Input', type: 'dollar' },
    { name: 'Date Input', type: 'date' },
    { name: 'Contact Input', type: 'contact' },
    { name: 'Agent Input', type: 'agent' },
    // { name: 'Custom Selector', type: 'enum' },
    { name: 'Transaction Category Selector', type: 'tranCategory' },
    { name: 'Deal Status Selector', type: 'dealStatus' },
  ];

  return (
    <div>
      <div>
        <Typography variant="h4" gutterBottom>
          Create a field for your template
        </Typography>

        <SimpleSelect
          label="Field Type"
          //   handleChange={handleChange}
          handleChange={e => setFieldType(e.target.value)}
          value={fieldType}
          name="type"
          containerStyle={{ width: '100%' }}
        >
          {fieldTypeList.map(({ type, name }) => (
            <MenuItem key={type} value={type}>
              {name}
            </MenuItem>
          ))}
        </SimpleSelect>
        <span style={{ fontSize: '0.85rem', color: colors.blueGrey[900] }}>
          Field Type is the input data type
        </span>

        <Formik
          // initialValues={initialValues}
          // validationSchema={DealTemplateSchema(items)}
          onSubmit={async (values, { resetForm, setSubmitting }) => {
            try {
              // setLoading(true);
              switch (fieldType) {
                case 'string':
                  addNewItem({
                    name: values.name,
                    type: 'string',
                    required: values.required,
                    displayName: values.displayName,
                    width: values.width,
                  });
                  break;
                case 'dollar':
                  addNewItem({
                    name: values.name,
                    type: 'dollar',
                    required: values.required,
                    displayName: values.displayName,
                    width: values.width,
                  });
                  break;
                case 'contact':
                  addNewItem({
                    name: values.name,
                    type: 'contact',
                    required: values.required,
                    displayName: values.displayName,
                    width: values.width,
                  });
                  break;
                case 'date':
                  addNewItem({
                    name: values.name,
                    type: 'date',
                    required: values.required,
                    displayName: values.displayName,
                    width: values.width,
                  });
                  break;
                case 'agent':
                  addNewItem({
                    name: values.name,
                    type: 'agent',
                    required: values.required,
                    displayName: values.displayName,
                    width: values.width,
                  });
                  break;
                case 'dealStatus':
                  addNewItem({
                    name: values.name,
                    type: 'enum',
                    required: values.required,
                    displayName: values.displayName,
                    width: values.width,
                    enumOptions: ['Draft', 'Submitted', 'Approved'],
                  });
                  break;
                case 'tranCategory':
                  addNewItem({
                    name: values.name,
                    type: 'tranCategory',
                    required: values.required,
                    displayName: values.displayName,
                    width: values.width,
                  });
                  break;
                default:
                  break;
              }
              setFieldType(null);
              handleClose();
              resetForm();
            } catch (e) {
              console.error(e);
            }
            setSubmitting(false);
            // setLoading(false);
          }}
          render={formikProps => {
            const {
              handleSubmit,
              isSubmitting,
              isValid,
              dirty,
              handleChange,
              handleBlur,
              setFieldValue,
              values,
            } = formikProps;
            return (
              <StyledForm onSubmit={handleSubmit}>
                <div>
                  <TextField
                    name="name"
                    label="Variable Name"
                    value={values.name}
                    margin="normal"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="outlined"
                    fullWidth
                    // pattern="^(\d|\w)+$"
                  />
                  <span
                    style={{ fontSize: '0.85rem', color: colors.blueGrey[900] }}
                  >
                    Variable names must start with a “$” e.g. “$DealName”
                  </span>
                  <TextField
                    name="displayName"
                    label="Input Name"
                    value={values.displayName}
                    margin="normal"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="outlined"
                    fullWidth
                  />
                  <span
                    style={{ fontSize: '0.85rem', color: colors.blueGrey[900] }}
                  >
                    Input name is the title that will appear over the field in
                    your template
                  </span>
                  <SimpleSelect
                    label="Input Width"
                    handleChange={handleChange}
                    value={values.width}
                    name="width"
                    containerStyle={{ width: '100%' }}
                  >
                    <MenuItem value={100}>Full Width</MenuItem>
                    <MenuItem value={50}>Half Width</MenuItem>
                  </SimpleSelect>
                  <span
                    style={{
                      fontSize: '0.85rem',
                      display: 'block',
                      color: colors.blueGrey[900],
                      marginBottom: '10px',
                    }}
                  >
                    Field width can be full or half width
                  </span>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!values.required}
                        onChange={(e, val) => {
                          setFieldValue('required', val);
                        }}
                        value={values.required}
                      />
                    }
                    label="Is Required"
                  />
                </div>
                <ButtonFlex>
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    size="large"
                    disabled={!dirty || isSubmitting}
                    style={{
                      margin: '5px',
                    }}
                  >
                    Add Field
                  </Button>
                </ButtonFlex>
              </StyledForm>
            );
          }}
        />
      </div>
    </div>
  );
};

export default AddField;

// case 'enum':
//   addNewItem({
//     name: values.name,
//     type: 'enum',
//     required: values.required,
//     displayName: values.displayName,
//     width: values.width,
//     // TODO: DYNAMIC
//     enumOptions: [
//       'Draft',
//       'Submitted',
//       'Approved',
//       'Closed',
//       'Void',
//       'Deleted',
//     ],
//   });
//   break;
